import { render, staticRenderFns } from "./tianmojieying.vue?vue&type=template&id=701a810b&scoped=true&"
import script from "./tianmojieying.vue?vue&type=script&lang=js&"
export * from "./tianmojieying.vue?vue&type=script&lang=js&"
import style0 from "./tianmojieying.vue?vue&type=style&index=0&id=701a810b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a810b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701a810b')) {
      api.createRecord('701a810b', component.options)
    } else {
      api.reload('701a810b', component.options)
    }
    module.hot.accept("./tianmojieying.vue?vue&type=template&id=701a810b&scoped=true&", function () {
      api.rerender('701a810b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/tianjiaoScoreManagement/tianmojieying.vue"
export default component.exports